import { render, staticRenderFns } from "./itemgroup.vue?vue&type=template&id=26d45d3c&scoped=true&"
import script from "./itemgroup.vue?vue&type=script&lang=js&"
export * from "./itemgroup.vue?vue&type=script&lang=js&"
import style0 from "./itemgroup.vue?vue&type=style&index=0&id=26d45d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d45d3c",
  null
  
)

export default component.exports